import type { GtmLeadContact } from '@laplace/contracts'

export type VerifiedContact = GtmLeadContact & {
  email: string
  status: 'valid'
}

/**
 * A contact a verifier or finder proved. An address published on the site,
 * guessed from a pattern, catch-all or unknown is not one: such leads are
 * neither shown as outreach nor sent to.
 */
export function isVerifiedContact(
  contact: GtmLeadContact | null | undefined,
): contact is VerifiedContact {
  return Boolean(contact?.email) && contact?.status === 'valid'
}
